import { releaseQuery, visitorLogQuery } from '../ReportsAPI';
import {
    createReleaseByWorkOrderID,
    createVisitorByWorkOrderID,
    prepareData,
    applyWorkOrders,
} from './helpers/maintenance.helper';

const defaultState = {
    timelineData: null,
};

export const turbineMaintenance = {
    name: 'turbineMaintenance',
    state: defaultState,

    reducers: {
        setMaintenanceData(state, { timelineData }) {
            return { ...state, timelineData };
        },
        resetMaintenanceData(state) {
            return { ...state, timelineData: null };
        },
    },

    effects: (dispatch) => ({
        async loadAll(_, state) {
            const maintenanceData = [
                ...(await prepareData(state, releaseQuery, 'return_time', createReleaseByWorkOrderID)),
                ...(await prepareData(state, visitorLogQuery, 'end_time', createVisitorByWorkOrderID)),
            ];

            const timelineData = await applyWorkOrders(state, maintenanceData);
            dispatch.turbineMaintenance.setMaintenanceData({ timelineData });
        },
    }),
};

export default turbineMaintenance;
